module.exports = __webpack_public_path__ + "static/img/btn3.586a755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/btn3.png
// module id = z0kW
// module chunks = 0